import * as Sentry from "@sentry/nuxt";
import { useRuntimeConfig } from "#imports";

const {
  public: { sentry },
} = useRuntimeConfig();

if (!sentry.dsn) {
  console.error("Sentry DSN not found");
}

Sentry.init({
  dsn: sentry.dsn,
  environment: sentry.environment,
  ignoreErrors: ["TypeError: Failed to fetch", "TypeError: Load failed"],
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  tracesSampleRate: 0.1,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [],

  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
});
